import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    .use(LanguageDetector)
    .use(XHR)
    .init({
        backend: {
            loadPath: '/langs/{{lng}}.json',
            //addPath: 'bundle-loader!./lang/missing',
        },

        detection:{
            order: ['querystring', 'cookie', 'localStorage', 'htmlTag'],
            lookupQuerystring: 'lang',
            lookupCookie: 'i18next_lang',
            lookupLocalStorage: 'i18next_Lng',
        },

        fallbackLng: 'pt',
        preload: ['pt', 'en', 'fr', 'de', 'es'],

        // have a common namespace used around the full app
        ns: ['translations'],
        defaultNS: 'translations',

        keySeparator: false, // we use content as keys

        interpolation: {
            escapeValue: false, // not needed for react!!
            formatSeparator: ','
        },

        react: {
            wait: true
        }
    }, (err, t) => {
        // ... 
    });

export default i18n;






// WEBPACK FOOTER //
// ./src/i18n.js